import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { acceptTerms, getTerms, type Terms } from "../lib/termsApi";
import { Toast } from "../components/Toast";
import "./TermsPage.css";

export default function TermsPage() {
  const navigate = useNavigate();
  const [terms, setTerms] = useState<Terms | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isAccepting, setIsAccepting] = useState(false);
  const [toast, setToast] = useState<
    { message: string; type?: "error" | "success" | "info" } | null
  >(null);

  useEffect(() => {
    loadTerms();
  }, []);

  const loadTerms = async () => {
    setIsLoading(true);
    try {
      const response = await getTerms();
      console.log("Resposta da API /terms:", response);
      setTerms(response.data);
    } catch (error: any) {
      console.error("Erro ao carregar termos:", error);
      setToast({
        message: error.message || "Erro ao carregar termos",
        type: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleAcceptTerms = async () => {
    if (!terms) return;

    setIsAccepting(true);
    try {
      const response = await acceptTerms({
        id: terms.id,
      });
      console.log("Resposta da API /checklist/terms:", response);
      setToast({
        message: "Termos aceitos com sucesso!",
        type: "success",
      });

      // Redirecionar para o checklist após 1.5 segundos
      setTimeout(() => {
        navigate("/checklist");
      }, 1500);
    } catch (error: any) {
      console.error("Erro ao aceitar termos:", error);
      setToast({
        message: error.message || "Erro ao aceitar termos",
        type: "error",
      });
    } finally {
      setIsAccepting(false);
    }
  };

  if (isLoading) {
    return (
      <div className="terms-page">
        <div className="terms-loading">
          <div className="loading-spinner"></div>
          <p>Carregando termos...</p>
        </div>
      </div>
    );
  }

  if (!terms) {
    return (
      <div className="terms-page">
        <div className="terms-error">
          <p>Erro ao carregar termos</p>
          <button onClick={loadTerms}>Tentar novamente</button>
        </div>
      </div>
    );
  }

  return (
    <div className="terms-page">
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}

      <div className="terms-container">
        <div className="terms-header">
          <div className="terms-header-content">
            <h1>📋 Termos de Uso</h1>
            <p>Leia atentamente antes de prosseguir</p>
          </div>
          <button
            className="back-button"
            onClick={() => navigate("/checklist")}
          >
            ← Voltar ao Checklist
          </button>
        </div>

        <div className="terms-content">
          <div className="terms-info">
            <div className="terms-info-item">
              <span className="label">Versão:</span>
              <span className="value">{terms.version}</span>
            </div>
            <div className="terms-info-item">
              <span className="label">Idioma:</span>
              <span className="value">{terms.language}</span>
            </div>
            <div className="terms-info-item">
              <span className="label">Última atualização:</span>
              <span className="value">
                {new Date(terms.updatedAt).toLocaleString("pt-BR")}
              </span>
            </div>
          </div>

          <div className="terms-text">
            {terms.content.split("\n").map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>

          <div className="terms-actions">
            <button
              className="accept-button"
              onClick={handleAcceptTerms}
              disabled={isAccepting}
            >
              {isAccepting ? "⏳ Processando..." : "✓ Aceitar Termos"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
